export class UnsupportedApplicationEventError extends Error {}
